<template>
  <party-template :type="1"/>
</template>

<script>
import PartyTemplate from '@/views/basedata/parties/PartyTemplate.vue'

export default {
  name: 'OwnerBaseData',
  components: { PartyTemplate }
}
</script>